export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN.ok";
export const LOGIN_FAILURE = "LOGIN.ex";
export const LOGOUT = "LOGOUT";

export const CHECKINAUTH = "CHECKINAUTH";
export const CHECKINAUTH_SUCCESS = "CHECKINAUTH.ok";
export const CHECKINAUTH_FAILURE = "CHECKINAUTH.ex";

export const CHECKIN_GENERIC = "CHECKIN_GENERIC";
export const CHECKIN_GENERIC_SUCCESS = "CHECKIN_GENERIC.ok";
export const CHECKIN_GENERIC_FAILURE = "CHECKIN_GENERIC.ex";

export const ADDITIONAL_DRIVER_AUTH = "ADDITIONAL_DRIVER_AUTH";
export const ADDITIONAL_DRIVER_AUTH_SUCCESS = "ADDITIONAL_DRIVER_AUTH.ok";
export const ADDITIONAL_DRIVER_AUTH_FAILURE = "ADDITIONAL_DRIVER_AUTH.ex";

export const CHECKIN = "CHECKIN";
export const CHECKIN_SUCCESS = "CHECKIN.ok";
export const CHECKIN_FAILURE = "CHECKIN.ex";
export const CHECKOUT = "CHECKOUT";

export const GETRENTALS = "GETRENTALS";
export const GETRENTALS_SUCCESS = "GETRENTALS.ok";
export const GETRENTALS_FAILURE = "GETRENTALS.ex";

export const GETDETAILS = "GETDETAILS";
export const GETDETAILS_SUCCESS = "GETDETAILS.ok";
export const GETDETAILS_FAILURE = "GETDETAILS.ex";

export const RETRIEVECUSTOMER = "RETRIEVECUSTOMER";
export const RETRIEVECUSTOMER_SUCCESS = "RETRIEVECUSTOMER.ok";
export const RETRIEVECUSTOMER_FAILURE = "RETRIEVECUSTOMER.ex";

export const SEARCHCUSTOMER = "SEARCHCUSTOMER";
export const SEARCHCUSTOMER_SUCCESS = "SEARCHCUSTOMER.ok";
export const SEARCHCUSTOMER_FAILURE = "SEARCHCUSTOMER.ex";

export const RETRIEVERESERVATION = "RETRIEVERESERVATION";
export const RETRIEVERESERVATION_SUCCESS = "RETRIEVERESERVATION.ok";
export const RETRIEVERESERVATION_FAILURE = "RETRIEVERESERVATION.ex";

export const RESESTIMATE = "RESESTIMATE";
export const RESESTIMATE_SUCCESS = "RESESTIMATE.ok";
export const RESESTIMATE_FAILURE = "RESESTIMATE.ex";

export const FRONTDESKRESESTIMATE = "FRONTDESKRESESTIMATE";
export const FRONTDESKRESESTIMATE_SUCCESS = "FRONTDESKRESESTIMATE.ok";
export const FRONTDESKRESESTIMATE_FAILURE = "FRONTDESKRESESTIMATE.ex";

export const RESOPTIONS = "RESOPTIONS";
export const RESOPTIONS_SUCCESS = "RESOPTIONS.ok";
export const RESOPTIONS_FAILURE = "RESOPTIONS.ex";

export const UPDATERESERVATION = "UPDATERESERVATION";
export const UPDATERESERVATION_SUCCESS = "UPDATERESERVATION.ok";
export const UPDATERESERVATION_FAILURE = "UPDATERESERVATION.ex";

export const SAVERESERVATIONOPTIONS = "SAVERESERVATIONOPTIONS";

export const UPDATERESERVATIONANDCUSTOMER = "UPDATERESERVATIONANDCUSTOMER";
export const UPDATERESERVATIONANDCUSTOMER_SUCCESS = "UPDATERESERVATIONANDCUSTOMER.ok";
export const UPDATERESERVATIONANDCUSTOMER_FAILURE = "UPDATERESERVATIONANDCUSTOMER.ex";

export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CREATE_CUSTOMER_SUCCESS = "CREATE_CUSTOMER.ok";
export const CREATE_CUSTOMER_FAILURE = "CREATE_CUSTOMER.ex";

export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER.ok";
export const UPDATE_CUSTOMER_FAILURE = "UPDATE_CUSTOMER.ex";

export const UPDATERESERVATIONANDCUSTOMER_CIF = "UPDATERESERVATIONANDCUSTOMER_CIF";
export const UPDATERESERVATIONANDCUSTOMER_CIF_SUCCESS = "UPDATERESERVATIONANDCUSTOMER_CIF.ok";
export const UPDATERESERVATIONANDCUSTOMER_CIF_FAILURE = "UPDATERESERVATIONANDCUSTOMER_CIF.ex";

export const MANUAL_UPDATERESERVATIONANDCUSTOMER = "MANUAL_UPDATERESERVATIONANDCUSTOMER";
export const MANUAL_UPDATERESERVATIONANDCUSTOMER_SUCCESS = "MANUAL_UPDATERESERVATIONANDCUSTOMER.ok";
export const MANUAL_UPDATERESERVATIONANDCUSTOMER_FAILURE = "MANUAL_UPDATERESERVATIONANDCUSTOMER.ex";

export const MANUAL_CREATE_CUSTOMER = "MANUAL_CREATE_CUSTOMER";
export const MANUAL_CREATE_CUSTOMER_SUCCESS = "MANUAL_CREATE_CUSTOMER.ok";
export const MANUAL_CREATE_CUSTOMER_FAILURE = "MANUAL_CREATE_CUSTOMER.ex";

export const MANUAL_UPDATE_CUSTOMER = "MANUAL_UPDATE_CUSTOMER";
export const MANUAL_UPDATE_CUSTOMER_SUCCESS = "MANUAL_UPDATE_CUSTOMER.ok";
export const MANUAL_UPDATE_CUSTOMER_FAILURE = "MANUAL_UPDATE_CUSTOMER.ex";

export const UPDATECUSTOMERCONTACT = "UPDATECUSTOMERCONTACT";

export const RESETVERIFYSTATUS = "RESETVERIFYSTATUS";
export const RESET_ID_VERIFY_STATUS = "RESET_ID_VERIFY_STATUS";

export const SET_CHECKIN_DEMO = "SET_CHECKIN_DEMO";

export const SET_IS_GENERIC_CHECKIN = "SET_IS_GENERIC_CHECKIN";

export const SET_REQUIRE_REVERIFY_CC = "SET_REQUIRE_REVERIFY_CC";
export const SET_REQUIRE_REVERIFY_ID = "SET_REQUIRE_REVERIFY_ID";

export const GET_UPCOMING_OCRLABS_OUTAGE = "GET_UPCOMING_OCRLABS_OUTAGE";
export const GET_UPCOMING_OCRLABS_OUTAGE_SUCCESS = "GET_UPCOMING_OCRLABS_OUTAGE.ok";
export const GET_UPCOMING_OCRLABS_OUTAGE_FAILURE = "GET_UPCOMING_OCRLABS_OUTAGE.ex";
export const ID_VERIFICATION_SKIPPED = "ID_VERIFICATION_SKIPPED";
export const ID_VERIFICATION_REQUIRED = "ID_VERIFICATION_REQUIRED";

export const SENDNOTIFICATION = "SENDNOTIFICATION";
export const SENDNOTIFICATION_SUCCESS = "SENDNOTIFICATION.ok";
export const SENDNOTIFICATION_FAILURE = "SENDNOTIFICATION";

export const SEARCHADDRESS = "SEARCHADDRESS";
export const SEARCHADDRESS_SUCCESS = "SEARCHADDRESS.ok";
export const SEARCHADDRESS_FAILURE = "SEARCHADDRESS.ex";

export const RETRIEVEADDRESS = "RETRIEVEADDRESS";
export const RETRIEVEADDRESS_SUCCESS = "RETRIEVEADDRESS.ok";
export const RETRIEVEADDRESS_FAILURE = "RETRIEVEADDRESS.ex";

export const VERIFYEMAIL = "VERIFYEMAIL";
export const VERIFYEMAIL_SUCCESS = "VERIFYEMAIL.ok";
export const VERIFYEMAIL_FAILURE = "VERIFYEMAIL.ex";

export const VERIFYPHONE = "VERIFYPHONE";
export const VERIFYPHONE_SUCCESS = "VERIFYPHONE.ok";
export const VERIFYPHONE_FAILURE = "VERIFYPHONE.ex";

export const REPAIRADDRESS = "REPAIRADDRESS";
export const REPAIRADDRESS_SUCCESS = "REPAIRADDRESS.ok";
export const REPAIRADDRESS_FAILURE = "REPAIRADDRESS.ex";

export const CREATE_TOAST = "CREATE_TOAST";
export const DELETE_TOAST = "DELETE_TOAST";

export const OPEN_POPPER = "OPEN_POPPER";
export const CLOSE_POPPER = "CLOSE_POPPER";

export const UPDATE_PHOTOS = "UPDATE_PHOTOS";
export const UPDATE_PHOTOS_SUCCESS = "UPDATE_PHOTOS.ok";
export const UPDATE_PHOTOS_FAILURE = "UPDATE_PHOTOS.ex";

export const REFRESH_PHOTOS = "REFRESH_PHOTOS";
export const REFRESH_PHOTOS_SUCCESS = "REFRESH_PHOTOS.ok";
export const REFRESH_PHOTOS_FAILURE = "REFRESH_PHOTOS.ex";

export const EXTEND_SESSION = "EXTEND_SESSION";

//Windcave API
export const REQUEST_WINDCAVEHPP = "WINDCAVE";
export const REQUEST_WINDCAVEHPP_SUCCESS = "WINDCAVE.ok";
export const REQUEST_WINDCAVEHPP_FAILURE = "WINDCAVE.ex";

export const WINDCAVE_STATUS = "WINDCAVE_STATUS";
export const WINDCAVE_STATUS_SUCCESS = "WINDCAVE_STATUS.ok";
export const WINDCAVE_STATUS_FAILURE = "WINDCAVE_STATUS.ex";

export const WINDCAVE_UPDATE = "WINDCAVE_UPDATE";

//IdVerification API
export const IDV_SKIP = "IDV_SKIP";
export const WINDCAVE_SKIP = "WINDCAVE_SKIP";
export const REQUEST_IDVERIFICATION_TRANSACTION = "REQUEST_IDV_TRANSACTION";
export const REQUEST_IDVERIFICATION_TRANSACTION_SUCCESS = "REQUEST_IDV_TRANSACTION.ok";
export const REQUEST_IDVERIFICATION_TRANSACTION_FAILURE = "REQUEST_IDV_TRANSACTION.ex";

export const REQUEST_IDVERIFICATION_STATUS = "REQUEST_IDV_STATUS";
export const REQUEST_IDVERIFICATION_STATUS_SUCCESS = "REQUEST_IDV_STATUS.ok";
export const REQUEST_IDVERIFICATION_STATUS_FAILURE = "REQUEST_IDV_STATUS.ex";

export const SEND_SMS_INVITE = "SEND_SMS_INVITE";
export const SEND_SMS_INVITE_SUCCESS = "SEND_SMS_INVITE.ok";
export const SEND_SMS_INVITE_FAILURE = "SEND_SMS_INVITE.ex";

export const GET_BRAND_LOCATIONS = "GET_BRAND_LOCATIONS";
export const GET_BRAND_LOCATIONS_SUCCESS = "GET_BRAND_LOCATIONS.ok";
export const GET_BRAND_LOCATIONS_FAILURE = "GET_BRAND_LOCATIONS.ex";

//vir
export const ATHENA_AUTH = "ATHENA_AUTH";
export const ATHENA_AUTH_SUCCESS = "ATHENA_AUTH.ok";
export const ATHENA_AUTH_FAILURE = "ATHENA_AUTH.ex";

export const ATHENA_VIR_AUTH = "ATHENA_VIR_AUTH";
export const ATHENA_VIR_AUTH_SUCCESS = "ATHENA_VIR_AUTH.ok";
export const ATHENA_VIR_AUTH_FAILURE = "ATHENA_VIR_AUTH.ex";

export const ATHENA_LOGOUT = "ATHENA_LOGOUT";
export const ATHENA_VIR_PREPARE_BE = "ATHENA_VIR_PREPARE_BE"; // "BE" means we only store in our own backend
export const ATHENA_VIR_PREPARE_THERMEON = "ATHENA_VIR_PREPARE_THERMEON"; // "THERMEON" means these params will be sent to thermeon to create a vir

export const ATHENA_VIR_WINDSCREEN = "ATHENA_VIR_WINDSCREEN";
export const ATHENA_VIR_PANEL = "ATHENA_VIR_PANEL";
export const ATHENA_VIR_VEHICLE_THEFT_TYPE = "ATHENA_VIR_VEHICLE_THEFT_TYPE";

export const ATHENA_VIR_USER = "ATHENA_VIR_USER";
export const ATHENA_VIR_USER_SUCCESS = "ATHENA_VIR_USER.ok";
export const ATHENA_VIR_USER_FAILURE = "ATHENA_VIR_USER.ex";

export const ATHENA_VIR_SERVICETRACKING = "ATHENA_VIR_SERVICETRACKING";
export const ATHENA_VIR_SERVICETRACKING_SUCCESS = "ATHENA_VIR_SERVICETRACKING.ok";
export const ATHENA_VIR_SERVICETRACKING_FAILURE = "ATHENA_VIR_SERVICETRACKING.ex";

export const ATHENA_VIR_DETAIL = "ATHENA_VIR_DETAIL";
export const ATHENA_VIR_DETAIL_SUCCESS = "ATHENA_VIR_DETAIL.ok";
export const ATHENA_VIR_DETAIL_FAILURE = "ATHENA_VIR_DETAIL.ex";

// export const ATHENA_VIR_INTIALIZE = "ATHENA_VIR_INTIALIZE";
// export const ATHENA_VIR_INTIALIZE_SUCCESS = "ATHENA_VIR_INTIALIZE.ok";
// export const ATHENA_VIR_INTIALIZE_FAILURE = "ATHENA_VIR_INTIALIZEex";

export const ATHENA_VIR_DETAIL_PATCH = "ATHENA_VIR_DETAIL_PATCH";
export const ATHENA_VIR_DETAIL_PATCH_SUCCESS = "ATHENA_VIR_DETAIL_PATCH.ok";
export const ATHENA_VIR_DETAIL_PATCH_FAILURE = "ATHENA_VIR_DETAIL_PATCH.ex";

// export const ATHENA_VIR_INIT = "ATHENA_VIR_INIT";
export const ATHENA_VIR_THEFT = "ATHENA_VIR_THEFT";

export const ATHENA_VIR_CREATE = "ATHENA_VIR_CREATE";
export const ATHENA_VIR_CREATE_SUCCESS = "ATHENA_VIR_CREATE.ok";
export const ATHENA_VIR_CREATE_FAILURE = "ATHENA_VIR_CREATE.ex";

export const ATHENA_DAMAGE_PRESIGNED = "ATHENA_DAMAGE_PRESIGNED";
export const ATHENA_DAMAGE_PRESIGNED_SUCCESS = "ATHENA_DAMAGE_PRESIGNED.ok";
export const ATHENA_DAMAGE_PRESIGNED_FAILURE = "ATHENA_DAMAGE_PRESIGNED.ex";
export const RESET_ADDRESS_SEARCH = "RESET_ADDRESS_SEARCH";

export const ATHENA_DAMAGE_PHOTO_ZIP = "ATHENA_DAMAGE_PHOTO_ZIP";
export const ATHENA_DAMAGE_PHOTO_ZIP_SUCCESS = "ATHENA_DAMAGE_PHOTO_ZIP.ok";
export const ATHENA_DAMAGE_PHOTO_ZIP_FAILURE = "ATHENA_DAMAGE_PHOTO_ZIP.ex";

export const ATHENA_EXTEND_SESSION = "ATHENA_EXTEND_SESSION";
export const ATHENA_VIR_DELETE = "ATHENA_VIR_DELETE";
export const ATHENA_VIR_RESUBMIT = "ATHENA_VIR_RESUBMIT";
export const ATHENA_VIR_CLEAN = "ATHENA_VIR_CLEAN";
export const ATHENA_SELECTED_TYPE = "ATHENA_SELECTED_TYPE";
export const ATHENA_SELECTED_ID = "ATHENA_SELECTED_ID";
export const ATHENA_APP_LOADING = "ATHENA_APP_LOADING";
export const ATHENA_SOURCE = "ATHENA_SOURCE";
export const ATHENA_REPORT_TYPE = "ATHENA_REPORT_TYPE";
export const ATHENA_ROLE = "ATHENA_ROLE";
export const ATHENA_INIT_APP_SMS = "ATHENA_INIT_APP_SMS";
export const ATHENA_PHOTOS_CLEANUP = "ATHENA_PHOTOS_CLEANUP";

export const VIR_SEND_CONTACT = "VIR_SEND_CONTACT";
export const VIR_SEND_CONTACT_SUCCESS = "VIR_SEND_CONTACT_SUCESS";
export const VIR_SEND_CONTACT_FAILURE = "VIR_SEND_CONTACT_FAILURE";
export const VIR_RESET_CONTACT = "VIR_RESET_CONTACT";

// rental module
export const RENTAL_LOGIN = "RENTAL_LOGIN";
export const RENTAL_LOGOUT = "RENTAL_LOGOUT";
export const RENTAL_LOGIN_SUCCESS = "RENTAL_LOGIN.ok";
export const RENTAL_LOGIN_FAILURE = "RENTAL_LOGIN.ex";

export const UPDATE_RETURN_DATE = "UPDATE_RETURN_DATE";
export const UPDATE_RETURN_DATE_SUCCESS = "UPDATE_RETURN_DATE.ok";
export const UPDATE_RETURN_DATE_FAILURE = "UPDATE_RETURN_DATE.ex";

export const RENTAL_ERROR_ALERT_CLOSE = "RENTAL_ERROR_ALERT_CLOSE";
export const RENTAL_ERROR_ALERT_OPEN = "RENTAL_ERROR_ALERT_OPEN";

export const SET_ELIGIBLE_FLAG = "SET_ELIGIBLE_FLAG";
